import { Box, ButtonBase, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { Mono } from './Mono';
import { useModeTokens } from './useModeTokens';
import { formatDateWithTime } from '@/common/utils/fileUtils';
export function VersionHistoryButton({
  version,
  selected,
  latest,
  expanded,
  detailsId,
  label,
  onSelect,
}: {
  version: { version: number; commitMessage: string; createdAt: string };
  selected: boolean;
  latest: boolean;
  expanded?: boolean;
  detailsId?: string;
  label?: string;
  onSelect: () => void;
}) {
  const t = useModeTokens();
  const displayLabel = label || version.commitMessage || 'No version message';
  return (
    <ButtonBase
      onClick={onSelect}
      aria-pressed={selected}
      aria-expanded={expanded}
      aria-controls={expanded === undefined ? undefined : detailsId}
      aria-label={`View version ${version.version}: ${displayLabel}`}
      sx={{
        width: '100%',
        textAlign: 'left',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 2,
        px: 3,
        py: 2.5,
        borderRadius: 0,
        borderLeft: '1px solid',
        borderColor: selected ? 'primary.main' : 'transparent',
        bgcolor: selected ? t.surfaces.fillActive : 'transparent',
        '&:hover': { bgcolor: t.surfaces.fillHover },
        '&.Mui-focusVisible': {
          outline: '2px solid',
          outlineColor: 'primary.main',
          outlineOffset: -2,
        },
      }}
    >
      <Mono
        size={12}
        color={selected ? t.colors.accentText : t.text.secondary}
        sx={{ pt: 0.25, flexShrink: 0 }}
      >
        v{version.version}
      </Mono>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          variant="body2"
          sx={{ fontWeight: selected ? 600 : 400, overflowWrap: 'anywhere' }}
        >
          {displayLabel}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', mt: 0.5 }}
        >
          {formatDateWithTime(version.createdAt)}
        </Typography>
        {latest && (
          <Typography
            variant="caption"
            sx={{ color: t.colors.accentText, display: 'block', mt: 0.5 }}
          >
            Latest version
          </Typography>
        )}
      </Box>
      {expanded !== undefined && (
        <ExpandMore
          aria-hidden="true"
          sx={{
            mt: 0.25,
            flexShrink: 0,
            color: 'text.secondary',
            transform: expanded ? 'rotate(180deg)' : 'none',
            transition: (theme) =>
              theme.transitions.create('transform', {
                duration: theme.transitions.duration.shortest,
              }),
          }}
        />
      )}
    </ButtonBase>
  );
}
